var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('h6',[_vm._v("Developed in Vue, visit "),_c('a',{attrs:{"href":_vm.linkUrl}},[_vm._v(_vm._s(_vm.linkUrl))])])])}
var staticRenderFns = []

export { render, staticRenderFns }